var render, staticRenderFns
import script from "./Communication.vue?vue&type=script&lang=ts&"
export * from "./Communication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0767c217",
  null
  
)

export default component.exports